module.exports = __webpack_public_path__ + "img/home-graphic-en-BE-mobile.de1d7677.png";